import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogResult, DialogService, DspxCardSetBaseFormComponent, SpinnerService } from 'dspx-core';
import { finalize, take } from 'rxjs';
import { API_ENDPOINTS } from 'src/app/constants/api-endpoints.constants';
import { POP_UP_CODES, SAVE_RESULT_STATUS, SERVER_ERROR_POP_UP_CODES } from 'src/app/constants/app-data.constants';
import { TEMPLATES } from 'src/app/constants/templates.constants';
import { JobSaveRequest } from 'src/app/models/job-save-request';
import { AppDataService } from 'src/app/services/app-data.service';
import { ErrorService } from 'src/app/services/error.service';
import { ROUTE_CONSTANTS } from '../../constants/route.constants';
import { ResponseParserService } from '../../services/response-parser.service';
import { BaseCardSetListComponent } from '../base-card-set-list-component/base-card-set-list.component';

@Component({
  selector: 'job-schedule-list',
  templateUrl: './job-schedule-list.component.html',
  styleUrl: './job-schedule-list.component.scss'
})
export class JobScheduleListComponent extends BaseCardSetListComponent implements OnInit, OnDestroy {
  @ViewChild(DspxCardSetBaseFormComponent)
  private set _baseForm(value: DspxCardSetBaseFormComponent) {
    this.baseForm = value
  }

  activeDialog: string = '';

  constructor(
    protected router: Router,
    protected spinnerService: SpinnerService,
    protected dialogService: DialogService,
    protected responseParserService: ResponseParserService,
    protected appDataService: AppDataService,
    private errorService: ErrorService,) {
    super(
      router,
      spinnerService,
      dialogService,
      responseParserService,
      appDataService,
      TEMPLATES.jobScheduleList,
      () => API_ENDPOINTS.dashboard.getJobSchedules,
      false);
  }

  ngOnInit(): void { }

  ngOnDestroy(): void {
    this.unsubscribeSubscriptions();
  }

  formLoad($event: any) {
    this.loadGridDataOnFormLoad();
  }

  actionButton_jobScheduleGrid_datagrid_new_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.jobSchedule.prefix]);
  }

  actionButton_jobScheduleGrid_datagrid_custom_refresh_Clicked(event: any): void {
    this.reloadPage();
  }

  actionButton_jobScheduleGrid_datagrid_run_Clicked(event: any): void {
    this.activeDialog = POP_UP_CODES.jobScheduler.confirmRunRequest;
    this.dialogService.showConfirm(this.activeDialog)
      .pipe(take(1))
      .subscribe(data => {
        data = data as DialogResult;
        if (data === DialogResult.ACCEPTED) {
          this.spinnerService.showSpinner();
          this.runAdHocJob(event.event.data.jobTypeId, event.event.data.id);
        }
      });
  }

  actionButton_jobScheduleGrid_datagrid_schedule_Clicked(event: any): void {
    this.router.navigate(['/', ROUTE_CONSTANTS.jobSchedule.prefix, event.event.data.id]);
  }

  actionButton_jobScheduleGrid_datagrid_delete_Clicked(event: any): void {
    this.activeDialog = POP_UP_CODES.jobScheduler.confirmDelete;
    this.dialogService.showConfirm(this.activeDialog)
      .pipe(take(1))
      .subscribe(data => {
        data = data as DialogResult;
        if (data === DialogResult.ACCEPTED) {
          this.spinnerService.showSpinner();
          this.deleteJobSchedule(event.event.data.id);
        }
      });
  }

  private runAdHocJob(jobTypeId: string, jobScheduleId: string) {
    const endpoint = API_ENDPOINTS.job.runAdHoc;
    let request = new JobSaveRequest();
    request.jobTypeId = jobTypeId;
    request.jobScheduleId = jobScheduleId;
    this.registerSubscription(
      this.appDataService.post(endpoint, request)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            this.reloadPage();
          }
        })
    );
  }

  private deleteJobSchedule(id: string) {
    const endpoint = `${API_ENDPOINTS.jobSchedule.delete}/${id}`;
    this.registerSubscription(
      this.appDataService.post(endpoint, null)
        .pipe(
          take(1),
          this.errorService.errorHandler(),
          finalize(() => this.spinnerService.hideSpinner())
        )
        .subscribe(data => {
          if (data?.status === SAVE_RESULT_STATUS.success) {
            if (SERVER_ERROR_POP_UP_CODES.deleteJobSchedule.includes(data.message)) {
              this.activeDialog = data.message;
              this.dialogService.showDialog(this.activeDialog);
            }
            else {
              this.reloadPage();
            }
          }
        })
    );
  }
}
